// The dashboard slug contract, shared by the worker (validation on create
// and on the dashboard-slug edit panel) and the client (native form
// validation in the New script modal). Mirrors the dashboard worker's own
// SLUG_RE (ss-custom-client-dashboard src/worker/index.ts). Keep these in
// sync; a mismatch surfaces as a 400 from the dashboard API at request time.
export const DASHBOARD_SLUG_RE = /^[a-z0-9][a-z0-9-]{0,62}$/;

// Same rule as an HTML `pattern` attribute. Browsers compile `pattern` with
// the `v` flag and anchor it themselves, so the hyphen inside the class must
// be escaped and there are no anchors here.
export const DASHBOARD_SLUG_HTML_PATTERN = '[a-z0-9][a-z0-9\\-]{0,62}';

export const DASHBOARD_SLUG_HINT =
  'Lowercase letters, digits and hyphens, starting with a letter or digit, up to 63 characters';

/**
 * Normalise a slug as it is typed so the native `pattern` check sees the
 * same value the form will send: the submit handlers trim, and a pasted
 * `Gigi-InStyle ` should not block an optional field.
 */
export function normaliseDashboardSlugInput(value: string): string {
  return value.trim().toLowerCase();
}
